import script from "./ChangeStatusModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChangeStatusModal.vue?vue&type=script&setup=true&lang=ts"

import "./ChangeStatusModal.vue?vue&type=style&index=0&id=535f743e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-535f743e"]])

export default __exports__